import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import Property from './Property'

export default function PharmacyProperty({ label, data }) {
  if (!data) return <Property label={label}>—</Property>

  const subtitle = [data.city, data.state].filter(Boolean).join(', ')

  return (
    <Property label={label}>
      <Stack spacing={-0.5}>
        <Typography>{data.name}</Typography>
        {subtitle && <Typography sx={{ color: 'text.secondary' }}>{subtitle}</Typography>}
      </Stack>
    </Property>
  )
}

PharmacyProperty.Loading = function ({ label }) {
  return (
    <Property label={label}>
      <Stack spacing={-0.5}>
        <Typography>
          <Skeleton width={150} />
        </Typography>
        <Typography>
          <Skeleton width={100} />
        </Typography>
      </Stack>
    </Property>
  )
}
